export interface WindowSize {
  width?: number;
  height?: number;
  // Sem medida nenhuma: quem dimensiona é o conteúdo, entre o piso e o teto que o
  // CSS impõe. Fica no tamanho e não em `width` para não obrigar largura fixa.
  auto?: boolean;
}

export type WindowPreset = 'sm' | 'md' | 'lg' | 'xl' | 'auto';

export const WINDOW_PRESETS: Record<Exclude<WindowPreset, 'xl' | 'auto'>, WindowSize> = {
  sm: { width: 500, height: 400 },
  md: { width: 750, height: 500 },
  lg: { width: 900, height: 600 },
};

export function resolveWindowSize(size: WindowSize | WindowPreset): WindowSize {
  if (typeof size === 'string') {
    if (size === 'xl') return { width: window.innerWidth, height: window.innerHeight };
    if (size === 'auto') return { auto: true };
    return WINDOW_PRESETS[size];
  }
  return size;
}

export interface WindowConfig {
  id: string;
  title: string;
  component: React.ComponentType<any>;
  props?: any;
  size?: WindowSize;
  zIndex: number;
  loading?: boolean;
  data?: any;
  containerElement?: HTMLElement;
  onClose?: (result?: any) => void;
}

export interface WindowManagerContextType {
  windows: WindowConfig[];
  openWindow: (config: Omit<WindowConfig, 'id' | 'zIndex'>) => string;
  closeWindow: (id: string, result?: any) => void;
  focusWindow: (id: string) => void;
  updateWindowData: (id: string, data: any, loading?: boolean) => void;
}
